export const SUBSCRIPTION_PLAN_BILL = 'SubscriptionPlanBill'
export const PAYMENT = 'Payment'
